export interface CookieConfig {
    expiresIn: number | null;
    mainBody: string;
    path?: string;
}

export const setCookie = (cookieConfig: CookieConfig): void => {
    let cookieExpires = "";
    if (cookieConfig.expiresIn !== null) {
        const date = new Date();
        date.setTime(date.getTime() + cookieConfig.expiresIn);
        cookieExpires = " expires=" + date.toUTCString() + "; ";
    }
    const cookieDomain =
        window.location.hostname.substr(-10) === "trumpf.com"
            ? ".trumpf.com; "
            : window.location.hostname + "; ";
    document.cookie =
        cookieConfig.mainBody +
        cookieExpires +
        "domain=" +
        cookieDomain +
        `path=${cookieConfig.path || "/"};`;
};
